export default __webpack_public_path__ + "static/media/workcafe-0.94357867.JPG";